<script lang="ts" setup>
import type { TestimonialsData } from '~~/server/api/insurance/assistance-services'
import type { QuoteData } from '~/components/quote/Quote.vue'

export interface PagesAssistanceServicesTesimonialsItemProps {
    testimonial: TestimonialsData
}

const props = defineProps<PagesAssistanceServicesTesimonialsItemProps>()

const data = computed<QuoteData>((): QuoteData => {
    return {
        description: props.testimonial.description,
        name: props.testimonial.name,
        position: props.testimonial.service?.title || '',
        image: props.testimonial.image,
        link: props.testimonial.link,
    }
})
</script>

<template>
  <Quote
    :data="data"
    description-classes="fs-bigger lh-lg"
    cite-classes="text-secondary fw-bold"
    class="border box-shadow-0 h-100 d-lg-flex flex-column justify-content-between"
  />
</template>
